// For a getter you will just need to map the state with the property.
export default {
  loggedIn: state => state.loggedIn,
  userGroup: state => state.userGroup,
  user: state => state.user,
}
